<template>
  <v-list-group no-action :prepend-icon="item.icon" :class="item.hidden" dense>
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-subtitle class="font-weight-bold black--text">{{item.title}}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <span v-for="(subItem, j) in item.items" :key="j">
        <ListGroupitemTwo v-if="subItem.group" :item="subItem" :on-success="ItemAction"/>
        <ListItem v-else :item="subItem" :on-success="ItemAction"/>
    </span>
  </v-list-group>
</template>

<script>
import ListItem from '@/components/core/menu/ListItem'
import ListGroupitemTwo from '@/components/core/menu/ListGroupitemTwo'
export default {
  name: 'GroupTtem',
  props: ['item', 'OnSuccess'],
  data: () => ({}),
  components: {
    ListItem,
    ListGroupitemTwo
  },
  methods: {
    ItemAction (item) {
      this.OnSuccess(item)
    }
  }
}
</script>
<style>
</style>
